import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import Roles from 'utils/enums/Roles';

import { GroupingsList } from './Groupings/GroupingsList';
import { ModuleSelectionsDetail } from './ModuleSelections/ModuleSelectionDetail';
import { ModuleSelections } from './ModuleSelections/ModuleSelectionsList';
import { SubjectType } from './ModuleSelections/models';
import { ModuleDetailView } from './Modules/ModuleDetailView/ModuleDetailView';
import { ModulesList } from './Modules/ModulesList';
import { ModuleSelectionsStudentView } from './StudentView/ModuleSelection';
import { ModuleSelectionStudentDetailView } from './StudentView/ModuleSelectionDetailView';

export const Awpm = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        path="modules"
        element={
          <PrivateRoute
            requires={{
              entitlements: [Roles.AWPM_ADMIN]
            }}
            user={currentUser}
          >
            <ModulesList subjectType={SubjectType.Awpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="modules/:id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR, Roles.STUDENT]
            }}
            user={currentUser}
          >
            <ModuleDetailView subjectType={SubjectType.Awpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="module-selections"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR]
            }}
            user={currentUser}
          >
            <ModuleSelections subjectType={SubjectType.Awpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="module-selections/:id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR]
            }}
            user={currentUser}
          >
            <ModuleSelectionsDetail subjectType={SubjectType.Awpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="student/module-selections"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT]
            }}
            user={currentUser}
          >
            <ModuleSelectionsStudentView subjectType={SubjectType.Awpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="student/module-selections/:id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT]
            }}
            user={currentUser}
          >
            <ModuleSelectionStudentDetailView subjectType={SubjectType.Awpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="groupings"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR]
            }}
            user={currentUser}
          >
            <GroupingsList />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
export const Fwpm = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        path="modules"
        element={
          <PrivateRoute
            requires={{
              fpwm_admin: true
            }}
            user={currentUser}
          >
            <ModulesList subjectType={SubjectType.Fwpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="modules/:id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR, Roles.STUDENT]
            }}
            user={currentUser}
          >
            <ModuleDetailView subjectType={SubjectType.Fwpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="module-selections"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR]
            }}
            user={currentUser}
          >
            <ModuleSelections subjectType={SubjectType.Fwpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="module-selections/:id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR]
            }}
            user={currentUser}
          >
            <ModuleSelectionsDetail subjectType={SubjectType.Fwpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="student/module-selections"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT]
            }}
            user={currentUser}
          >
            <ModuleSelectionsStudentView subjectType={SubjectType.Fwpm} />
          </PrivateRoute>
        }
      />
      <Route
        path="student/module-selections/:id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT]
            }}
            user={currentUser}
          >
            <ModuleSelectionStudentDetailView subjectType={SubjectType.Fwpm} />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
